// src/supabase/supabaseClient.ts
import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL!,
  process.env.REACT_APP_SUPABASE_ANON_KEY!
);

// profiles (이미 있음)
export async function getProfile(id: string) {
  const { data, error } = await supabase.from("profiles").select("*").eq("id", id).single();
  return { data, error };
}
export async function updateProfile({ id, ...rest }: { id: string; [key: string]: any }) {
  return await supabase.from("profiles").update(rest).eq("id", id);
}

// posts
export async function insertPost(post: any) {
  return supabase.from("posts").insert(post);
}
export async function fetchPosts(boardType?: string) {
  let query = supabase.from("posts").select("*").order("created_at", { ascending: false });
  if (boardType) query = query.eq("board_type", boardType);
  return query;
}
export async function updatePost(id: number, fields: any) {
  return supabase.from("posts").update(fields).eq("id", id);
}
export async function deletePost(id: number) {
  return supabase.from("posts").delete().eq("id", id);
}